import { ReactNode, useId } from 'react';

import Button from 'components/ui/button';
import { ModalFrame, ModalFrameSize } from 'components/ui/modal-frame';

interface NoticeModalProps {
  isOpen: boolean;
  title: string;
  size?: ModalFrameSize;
  /** Texto do aviso. Vira a descrição acessível do diálogo. */
  children: ReactNode;
  actionLabel: string;
  onAction: () => void;
  /** Botão de fechar do cabeçalho e Esc. */
  onClose: () => void;
  /** Nome acessível do botão de fechar. */
  closeLabel?: string;
}

/** Aviso na moldura dos modais da nova identidade: o texto e um botão de ação. */
export function NoticeModal({
  isOpen,
  title,
  size = 'sm',
  children,
  actionLabel,
  onAction,
  onClose,
  closeLabel,
}: NoticeModalProps) {
  const descriptionId = useId();

  return (
    <ModalFrame isOpen={isOpen} size={size} title={title} descriptionId={descriptionId} onClose={onClose} closeLabel={closeLabel}>
      <div className="flex flex-col items-center gap-5 px-5 py-6 lg:px-7">
        <div id={descriptionId} className="flex w-full flex-col gap-3 text-sm leading-[1.6] text-content [text-wrap:pretty]">
          {children}
        </div>

        <Button variant="solido-destaque" onClick={onAction}>
          {actionLabel}
        </Button>
      </div>
    </ModalFrame>
  );
}
